export class OfflineOrderProductAlreadyExists extends Error {
  constructor() {
    super('product already exists');
    this.name = 'OfflineOrderProductAlreadyExists';
  }
}
